exports.ImageUploadModule = require('./lib/image-upload.module').ImageUploadModule;



//////////////////
// WEBPACK FOOTER
// ./~/angular2-image-upload/index.js
// module id = 763
// module chunks = 33